import './accountBenefitsView.scss';

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const PureRenderMixin = require('react-addons-pure-render-mixin');
import { withRouter } from 'react-router-dom';
// @ components
const AccountBenefitsBox = require('./accountBenefitsBox/accountBenefitsBox');
const AccountBenefitsAccountInformationBox = require('./accountBenefitsAccountInformationBox/accountBenefitsAccountInformationBox');
const { LoadingSection } = require('commonsComponents/loadingSection');
const OKHeaderCC = require('components/commons/OKHeaderCC/OKHeaderCC');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox.js');
// @helpers
const { formatText } = require('core/i18n').i18n;
// @constants
const { EURO_SYMBOL } = require('constants/index');

class accountBenefitsView extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.onHandleGobackCustomMessageBox = this.onHandleGobackCustomMessageBox.bind(this);
    }

    componentWillMount() {
        this.getDataFromServices(this.props);
    }

    getDataFromServices(props) {
        const {
            match: { params: { accountId } },
            queryBenefits123Data
        } = props;

        queryBenefits123Data(accountId);
    }

    buildFetching() {
        return (
            <OKSectionBox>
                <LoadingSection />
            </OKSectionBox>
        );
    }

    onHandleGobackCustomMessageBox() {
        const { match: { params: { accountId } }, history } = this.props;
        history.push(`/myprofile/accounts/${accountId}/movements`);
    }

    buildFailure() {
        const title = formatText('accountBenefits-titleMessageBoxFailure');
        const textLink = formatText('accountBenefits-textLinkMessageBoxFailure');

        return (
            <CustomMessageBox
                icon="icon-warning"
                title={title}
                textLink={textLink}
                goBackHandler={this.onHandleGobackCustomMessageBox}
            />
        );
    }

    buildSuccess() {
        const { match: { params: { accountId } }, immAccounts, immAccountBenefitsData } = this.props;
        const immStockBenefits = immAccountBenefitsData.getIn(['accountBenefitsData', 'liquidacionTotal', 'acciones', 'acciones']);
        const immBenefits = immAccountBenefitsData.getIn(['accountBenefitsData', 'liquidacionTotal', 'recibos', 'recibos']);
        const immAccount = immAccounts.get('byId').get(accountId);
        const accountIban = immAccount.get('iban');

        const stocksTotal = immAccountBenefitsData.getIn(['accountBenefitsData', 'liquidacionTotal', 'accionesTotalAcumulado']);
        const stocksLatest = immAccountBenefitsData.getIn(['accountBenefitsData', 'liquidacionTotal', 'accionesUltimaLiquidacion']);
        const benefitsTotal = immAccountBenefitsData.getIn(['accountBenefitsData', 'liquidacionTotal', 'abonadoCuentaTotalAcumulado']);
        const benefitsLatest = immAccountBenefitsData.getIn(['accountBenefitsData', 'liquidacionTotal', 'abonadoCuentaUltimaLiquidacion']);
        const latestSettlementDate = immAccountBenefitsData.getIn(['accountBenefitsData', 'liquidacionTotal', 'fechaHasta']);

        return (
            <div className="row no-outside-gutter">
                <div className="col-xs-9">
                    <div className="account-benefits-view__main-content">
                        <AccountBenefitsBox
                            title={formatText('accountBenefits-benefits')}
                            immBenefits={immBenefits}
                            emptyStateText={formatText('accountBenefits-benefitsEmptyState')}
                            total={benefitsTotal}
                            latest={benefitsLatest}
                            units={EURO_SYMBOL}
                        />
                    </div>
                    <div className="account-benefits-view__main-content">
                        <AccountBenefitsBox
                            title={formatText('accountBenefits-stocks')}
                            immBenefits={immStockBenefits}
                            emptyStateText={formatText('accountBenefits-stocksEmptyState')}
                            total={stocksTotal}
                            latest={stocksLatest}
                        />
                    </div>
                </div>
                <div className="col-xs-3">
                    <div className="account-benefits-view__main-content">
                        <AccountBenefitsAccountInformationBox
                            accountNumber={accountIban}
                            immAccountBenefitsData={immAccountBenefitsData}
                            latestSettlementDate={latestSettlementDate}
                        />
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { match: { params: { accountId } }, immAccounts, immAccountBenefitsData } = this.props;
        const immStockBenefits = immAccountBenefitsData.getIn(['accountBenefitsData', 'liquidacionTotal', 'acciones', 'acciones']);
        const immBenefits = immAccountBenefitsData.getIn(['accountBenefitsData', 'liquidacionTotal', 'recibos', 'recibos']);
        const immAccount = immAccounts.getIn(['byId', accountId]);
        const error = immAccountBenefitsData.get('error');

        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-accounts'),
                url: '/myprofile/accounts'
            },
            {
                text: immAccount.get('alias'),
                url: `/myprofile/accounts/${accountId}/movements`
            },
            {
                text: formatText('accountBenefits-title'),
                url: ''
            }
        ];

        let sectionContent = this.buildFetching();

        if (error) {
            sectionContent = this.buildFailure();
        } else if (immAccount && immStockBenefits && immBenefits) {
            sectionContent = this.buildSuccess();
        }

        return (
            <div className="account-benefits-view">
                <OKHeaderCC
                    title="accountBenefits-title"
                    breadcrumbConfig={mappingBreadcrumb}
                    showBreadBrumb={true}
                />
                <div className="account-benefits-view__body">
                    {sectionContent}
                </div>
            </div>
        );
    }
}

accountBenefitsView.propTypes = {
    match: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immAccountBenefitsData: PropTypes.object,
    queryBenefits123Data: PropTypes.func,
    history: PropTypes.object.isRequired,
};

module.exports = withRouter(accountBenefitsView);
